import React, { useState } from 'react';
import { FaSearch, FaMapMarkerAlt, FaCheckCircle, FaTruck, FaBox } from 'react-icons/fa';
import api from '../services/api';
import './TrackShipment.css';

function TrackShipment() {
  const [trackingNumber, setTrackingNumber] = useState('');
  const [trackingData, setTrackingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setTrackingData(null);

    try {
      const response = await api.get(`/api/track/${trackingNumber}`);
      setTrackingData(response.data);
    } catch (err) {
      setError('Tracking number not found. Please check and try again.');
      // Demo data for presentation
      setTrackingData({
        trackingNumber: trackingNumber,
        status: 'In Transit',
        estimatedDelivery: 'Nov 11, 2025',
        currentLocation: 'New York Distribution Center',
        history: [
          { date: 'Nov 9, 2025 10:30 AM', location: 'New York, NY', status: 'Package picked up', icon: 'box' },
          { date: 'Nov 9, 2025 2:45 PM', location: 'New York Distribution Center', status: 'Arrived at facility', icon: 'building' },
          { date: 'Nov 9, 2025 6:20 PM', location: 'New York Distribution Center', status: 'Departed facility', icon: 'truck' },
          { date: 'Nov 10, 2025 8:15 AM', location: 'Philadelphia, PA', status: 'In transit', icon: 'truck' }
        ]
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="track-page">
      <section className="track-hero">
        <div className="container">
          <h1>Track Your Shipment</h1>
          <p>Enter your tracking number to see real-time updates</p>
        </div>
      </section>

      <section className="track-content">
        <div className="container">
          <div className="track-form-container">
            <form className="track-form" onSubmit={handleSubmit}>
              <div className="track-input-group">
                <input
                  type="text"
                  placeholder="Enter tracking number (e.g., EXP123456789)"
                  value={trackingNumber}
                  onChange={(e) => setTrackingNumber(e.target.value)}
                  required
                />
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  <FaSearch /> {loading ? 'Tracking...' : 'Track'}
                </button>
              </div>
            </form>

            {error && !trackingData && (
              <div className="error-message">
                {error}
              </div>
            )}
          </div>

          {trackingData && (
            <div className="tracking-results">
              <div className="tracking-summary">
                <div className="summary-card">
                  <FaBox className="summary-icon" />
                  <div>
                    <h3>Tracking Number</h3>
                    <p>{trackingData.trackingNumber}</p>
                  </div>
                </div>
                <div className="summary-card">
                  <FaTruck className="summary-icon" />
                  <div>
                    <h3>Status</h3>
                    <p className="status-badge">{trackingData.status}</p>
                  </div>
                </div>
                <div className="summary-card">
                  <FaMapMarkerAlt className="summary-icon" />
                  <div>
                    <h3>Current Location</h3>
                    <p>{trackingData.currentLocation}</p>
                  </div>
                </div>
                <div className="summary-card">
                  <FaCheckCircle className="summary-icon" />
                  <div>
                    <h3>Estimated Delivery</h3>
                    <p>{trackingData.estimatedDelivery}</p>
                  </div>
                </div>
              </div>

              <div className="tracking-timeline">
                <h2>Shipment History</h2>
                <div className="timeline">
                  {trackingData.history.map((item, index) => (
                    <div className="timeline-item" key={index}>
                      <div className="timeline-dot"></div>
                      <div className="timeline-content">
                        <div className="timeline-header">
                          <h4>{item.status}</h4>
                          <span className="timeline-date">{item.date}</span>
                        </div>
                        <p className="timeline-location">
                          <FaMapMarkerAlt /> {item.location}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="track-info">
            <h2>Tracking Information</h2>
            <div className="info-grid">
              <div className="info-item">
                <h3>Where to find your tracking number?</h3>
                <p>Your tracking number is provided in your shipment confirmation email or receipt. It's usually a 10-15 character alphanumeric code starting with "EXP".</p>
              </div>
              <div className="info-item">
                <h3>How often is tracking updated?</h3>
                <p>Tracking information is updated in real-time as your package moves through our network. Updates typically occur every 2-4 hours during transit.</p>
              </div>
              <div className="info-item">
                <h3>Need help?</h3>
                <p>If you can't find your tracking number or have questions about your shipment, contact our customer service team at +1 (555) 123-4567.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TrackShipment;

